<template>
  <el-dialog class="wx-dialog" :title="title" :visible.sync="options.show" close="cancel" :width="options.width">
    <div class="gallery-chart">
      <el-form ref="articleForm" :model="articleForm" >
        <el-form-item >
          <el-input v-model="articleForm.url" placeholder="请输入要导入文章的地址"></el-input>
        </el-form-item>
        </el-form-item>
      </el-form>
      <p class="gray-font">
        目前支持导入：微信公众号、QQ公众号、今日头条号、百家号、一点号、网易号、
        搜狐公众号、新浪博客、腾讯新闻、腾讯大家、新浪新闻、天天快报、网易新闻、知乎专栏。
      </p>
    </div>
    <div slot="footer" class="footer-dialog-article" style="text-align:center;margin-top:10px">
      <el-button type="success" :disabled="!articleForm.url" @click="submit('articleForm')">确定</el-button>
      <el-button type="success" @click="cancel">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import ArticleService from '@/service/api/articleService'
import _ from 'lodash'

export default {
  props: {
    metaData: {
      type: Object,
      default: {}
    },
    cancelFn: {
      type: Function,
      default: () => undefined
    },
    submitFn: {
      type: Function,
      default: () => undefined
    },
    options: {
      type: Object,
      default: {}
    },
    title: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      articleForm: {
        url: null
      }
    }
  },

  methods: {
    submit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const articleSystem = new ArticleService()
          articleSystem.importArticle(this.articleForm)
            .then(({data}) => {
              if (this.submitFn && typeof this.submitFn === 'function') {
                this.submitFn(data.data)
              }
              this.$destroy()
            }, (error) => {
            this.$notify.error(error.message)
            })
          this.$destroy()
        }
      })
    },

    cancel () {
      if (this.cancelFn && typeof this.cancelFn === 'function') {
        this.cancelFn()
      }
      this.$destroy()
    }
  },

  destroyed () {
    document
      .getElementById('app')
      .removeChild(this.$el)
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .gallery-chart{
    margin-top: 20px;
    .warn-chart{
      color: #444;
      line-height: 2;
    }
    .back-info{
      padding: 4px 8px;
      background: #f1f1f1;
      color: #9a9a9a;
      border-color: #f1f1f1;
      margin-left: 20px;
    }
    .gray-font{
      color: #adadad;
      margin: 15px 0
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dialog/importArticle.vue